module.exports = __webpack_public_path__ + "img/training_ojt.8bae7ea2.jpg";